import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import ShopManagement from "./pages/ShopManagement";
import CustomerManagement from "./pages/CustomerManagement";
import AdminManagement from "./pages/AdminManagement";
import ServiceManagement from "./pages/ServiceManagement";
import Settings from "./pages/Settings";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import BookingManangement from "./pages/BookingManangement";
import RevenueAnalytics from "./pages/RevenueAnalytics";

// Placeholder component for coming soon pages
const PlaceholderPage = ({ title, description }) => (
  <Layout>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      textAlign: 'center'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        maxWidth: '600px',
        width: '100%'
      }}>
        <div style={{
          fontSize: '48px',
          marginBottom: '20px',
          color: '#f59e0b',
          fontWeight: 'bold'
        }}>
          UNDER DEVELOPMENT
        </div>
        <h1 style={{
          margin: '0 0 15px 0',
          fontSize: '32px',
          fontWeight: '700',
          color: '#1e293b'
        }}>
          {title}
        </h1>
        <p style={{
          margin: '0 0 25px 0',
          fontSize: '16px',
          color: '#64748b',
          lineHeight: '1.6'
        }}>
          {description}
        </p>
        <div style={{
          backgroundColor: '#f1f5f9',
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          padding: '15px',
          marginTop: '20px'
        }}>
          <p style={{
            margin: 0,
            fontSize: '14px',
            color: '#475569',
            fontWeight: '500'
          }}>
            ⚡ This feature is currently under development and will be available soon!
          </p>
        </div>
      </div>
    </div>
  </Layout>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Navigate to="/login" replace />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        {/* Placeholder routes for sidebar navigation */}
        <Route
          path="/admins"
          element={
            <ProtectedRoute>
              <AdminManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <CustomerManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/shops"
          element={
            <ProtectedRoute>
              <ShopManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/services"
          element={
            <ProtectedRoute>
              <ServiceManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bookings"
          element={
            <ProtectedRoute>
              <BookingManangement />
            </ProtectedRoute>
          }
        />
        <Route path="/payments" element={<ProtectedRoute><Navigate to="/dashboard" replace /></ProtectedRoute>} />
        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <PlaceholderPage title="Notifications" description="Manage system notifications, send announcements, and configure notification settings." />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <RevenueAnalytics />
            </ProtectedRoute>
          }
        />
        <Route
          path="/messages"
          element={
            <ProtectedRoute>
              <PlaceholderPage title="Messages" description="Manage customer communications, support tickets, and platform messaging." />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
